module.exports = __webpack_public_path__ + "img/icono_menu.21968fe6.svg";